import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import createHistory from 'history/createBrowserHistory'
import { persistStore } from 'redux-persist'
import configureStore from './store'
import Root from './components/Root'

import './index.css';

const history = createHistory();
const store = configureStore(history)
const persistor = persistStore(store)

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Root />
        </PersistGate>
    </Provider>,
    document.getElementById('root')
)





// WEBPACK FOOTER //
// ./src/index.js